'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var useSortedArray_hook = require('./use-sorted-array.hook-154a130b.js');

var ASC = 'asc';
var DESC = 'desc';
var useAlphanumericSortedArray = function (items, key, order) {
    if (order === void 0) { order = ASC; }
    var sortFunction = React.useCallback(function (a, b) {
        var result = a[key].localeCompare(b[key]);
        return order === DESC ? result * -1 : result;
    }, [key, order]);
    return useSortedArray_hook.useSortedArray(items, sortFunction);
};

exports.useAlphanumericSortedArray = useAlphanumericSortedArray;
